import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DiscountsAndMultipliersService, Product, SalesDocument } from '@icc/b2b/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { SalesDocumentService } from '../sales-document.service';

@Component({
    selector: 'icc-added-product-dialog',
    templateUrl: './added-product-dialog.component.html',
    styleUrls: ['./added-product-dialog.component.scss'],
})
export class AddedProductDialogComponent {
    constructor(
        private salesDocumentService: SalesDocumentService,
        private discountsAndMultipliersService: DiscountsAndMultipliersService,
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            product: Product;
            document: SalesDocument,
            price: { value: number; currency: string; isGross: boolean; taxRate?: number };
            quantity: number;
            unit: {
                id: number;
                code:string;
                name: string;
                symbol: string;
                factorDesc: string;
            };
        },
        private router: Router
    ) {}

    close() {
        this.dialogRef.close();
    }

    goToOffer() {
        const document = this.salesDocumentService.getOpenedDocument();
        this.dialogRef.close();
        this.router.navigate(['trade', 'offer', document.uuid]);
    }
}
